/*
 App

 Definicja aplikacji 
 Ekran główny  - zobacz
 // https://material-ui.com/getting-started/page-layout-examples/
  
 historia: 
  PM 2021-09-07 - start
*/

import * as React from 'react';

import CONFIG, { window2config } from './cfg/config';

import { withStyles, WithStyles, MuiThemeProvider } from '@material-ui/core/styles';
import { Backdrop, Button, Grid, IconButton, Menu, MenuItem, Paper, Table, TableBody, TableCell, TableRow, Theme, Typography } from '@material-ui/core';

import theme from './themes';
import CardPolityka from './app/CardPolityka';
import MenuIcon from '@material-ui/icons/Menu';
import LinksAplikacje from './app/LinksAplikacje';
import ImgIcon from './app/ImgIcon';
import CardPlatnosc from './app/CardPlatnosc';
import LinksPlatnosci from './app/LinksPlatnosci';
import CardCookies from './app/CardCookies';
import CardWeb from './app/CardWeb';
import Google from './app/auth/Google';
import Facebook from './app/auth/Facebook';

import './style.css'
import FlagIcons from './app/components/FlagIcons';

//PM 2021-09-08
export class Aplikacja {
  text: string = '';
  value: string = '';
  src: string = '';

  constructor(data?: any) {
    if (data) {
      this.text = data.text;
      this.value = data.value;
      this.src = data.src;
    }
  }
}

//PM 2021-11-05
//usuniecie openCookiesSnackbar
interface AppState {
  regulaminy: string,
  aplikacja: Aplikacja,
  value: number,
  anchorEl: Element | ((element: Element) => Element) | null,
  lang: string
}

const menuItems = [
  {
    text: 'GooglePlay regulaminy aplikacji',
    src: 'img/ikony/GooglePlay.svg',
    alt: 'GooglePlay',
    value: 'GooglePlay',
    divider: false,
  },
  {
    text: 'Huawei AppGallery regulaminy aplikacji',
    src: 'img/ikony/AppGallery.svg',
    alt: 'Huawei AppGallery',
    value: 'AppGallery',
    divider: true,
  },
  {
    text: 'CashBill regulaminy płatności internetowych',
    src: 'img/ikony/CashBill.png',
    alt: 'CashBill',
    value: 'CashBill',
    divider: false,
  },
  {
    text: 'Przelewy24 regulaminy płatności internetowych',
    src: 'img/ikony/Przelewy24.svg',
    alt: 'Przelewy24',
    value: 'Przelewy24',
    divider: false,
  },
  {
    text: 'TPay regulaminy płatności internetowych',
    src: 'img/ikony/TPay.svg',
    alt: 'TPay',
    value: 'TPay',
    divider: false,
  },
  {
    text: 'PayU regulaminy płatności internetowych',
    src: 'img/ikony/PayU.png',
    alt: 'PayU',
    value: 'PayU',
    divider: false,
  },
]

export const aplikacje: Aplikacja[] = [
  {
    text: 'mAlert',
    value: 'mAlert',
    src: 'img/mAlert/ic_launcher.png'
  },
  {
    text: 'mBookuj',
    value: 'mBookuj',
    src: 'img/mBookuj/ic_launcher.png'
  },
  {
    text: 'mCzytnik',
    value: 'mCzytnik',
    src: 'img/mCzytnik/ic_launcher.png'
  },
  {
    text: 'mGłosowanie',
    value: 'mGlosowanie',
    src: 'img/mGlosowanie/ic_launcher.png'
  },
  {
    text: 'mGrafik',
    value: 'mGrafik',
    src: 'img/mGrafik/ic_launcher.png'
  },
  {
    text: 'mKelner',
    value: 'mKelner',
    src: 'img/mKelner/ic_launcher.png'
  },
  {
    text: 'mKelnerAuto',
    value: 'mKelnerAuto',
    src: 'img/mKelner/ic_launcher.png'
  },
  {
    text: 'mManager',
    value: 'mManager',
    src: 'img/mManager/ic_launcher.png'
  },
  {
    text: 'mNadzorca',
    value: 'mNadzorca',
    src: 'img/mNadzorca/ic_launcher.png'
  },
  {
    text: 'mPager',
    value: 'mPager',
    src: 'img/mPager/ic_launcher.png'
  },
  {
    text: 'mSms',
    value: 'mSms',
    src: 'img/mSms/ic_launcher.png'
  },
  {
    text: 'mSmsWeb',
    value: 'mSmsWeb',
    src: 'img/mSmsWeb/ic_launcher_round.png'
  },
  {
    text: 'mZałoga',
    value: 'mZaloga',
    src: 'img/mZałoga/ic_launcher_round.png'
  },
]

//PM 2021-12-10
//wyrzucenie hotel-TEST
export const platnosciPrzelewy24: Aplikacja[] = [
  {
    text: 'Standard',
    value: 'Standard',
    src: ''
  },
]

//PM 2021-11-05
//text: 'Standard',
export const platnosciTPay: Aplikacja[] = [
  {
    text: 'Standard',
    value: 'Standard',
    src: ''
  },
  {
    text: 'Virtual sc',
    value: 'Virtual',
    src: ''
  },
]

//PM 2021-12-10
export const Regulaminy: Aplikacja[] = [
  {
    text: 'Hotel Test',
    value: 'hotel-TEST',
    src: ''
  },
  {
    text: 'Żary-Hayduk',
    value: 'zary-HAYDUK-pobyt',
    src: ''
  },
  {
    text: 'Żary-Hayduk',
    value: 'zary-HAYDUK-wynajem',
    src: ''
  },
  {
    text: 'Żary-Hayduk',
    value: 'zary-HAYDUK-PDO',
    src: ''
  },
  {
    text: 'Zielona-Góra-Apart',
    value: 'zielona-gora-APART-pobyt',
    src: ''
  },
  {
    text: 'Zielona-Góra-Apart',
    value: 'zielona-gora-APART-wynajem',
    src: ''
  },
  {
    text: 'Zielona-Góra-Apart',
    value: 'zielona-gora-APART-PDO',
    src: ''
  },
  {
    text: 'zakopane-DOMKI-WIDOK',
    value: 'zakopane-DOMKI-WIDOK-pobyt',
    src: ''
  },
  {
    text: 'zakopane-DOMKI-WIDOK',
    value: 'zakopane-DOMKI-WIDOK-wynajem',
    src: ''
  },
  {
    text: 'zakopane-DOMKI-WIDOK',
    value: 'zakopane-DOMKI-WIDOK-PDO',
    src: ''
  },
  {
    text: 'wilcza-strefa',
    value: 'wilcza-strefa-pobyt',
    src: ''
  },
  {
    text: 'wilcza-strefa',
    value: 'wilcza-strefa-PDO',
    src: ''
  },
  {
    text: 'rzeszow-KULINARNE',
    value: 'rzeszow-KULINARNE-PDO',
    src: ''
  },
  {
    text: 'Zielona-Góra-Flat White',
    value: 'zielona-gora-FLAT-PDO',
    src: ''
  },
  {
    text: 'Zielona-Góra-Flat White',
    value: 'zielona-gora-FLAT-wynajem',
    src: ''
  },
  {
    text: 'lublin-SAS',
    value: 'lublin-SAS-pobyt',
    src: ''
  },
  {
    text: 'lublin-SAS',
    value: 'lublin-SAS-wynajem',
    src: ''
  },
  {
    text: 'lublin-SAS',
    value: 'lublin-SAS-PDO',
    src: ''
  },
  {
    text: 'lesko-SKI',
    value: 'lesko-SKI-karnet-doladowanie',
    src: ''
  },
  {
    text: 'lesko-SKI',
    value: 'lesko-SKI-karnet-regulamin',
    src: ''
  },
  {
    text: 'lesko-SKI',
    value: 'lesko-SKI-PDO',
    src: ''
  }, 
  {
    text: 'zielona-gora-GREEN-BB',
    value: 'zielona-gora-GREEN-BB-pobyt',
    src: ''
  },
  {
    text: 'zielona-gora-GREEN-BB',
    value: 'zielona-gora-GREEN-BB-wynajem',
    src: ''
  },
  {
    text: 'zielona-gora-GREEN-BB',
    value: 'zielona-gora-GREEN-BB-PDO',
    src: ''
  },
  {
    text: 'rymanow-WILLA-ZOFIA',
    value: 'rymanow-WILLA-ZOFIA-pobyt',
    src: ''
  },
  {
    text: 'rymanow-WILLA-ZOFIA',
    value: 'rymanow-WILLA-ZOFIA-wynajem',
    src: ''
  },
  {
    text: 'rymanow-WILLA-ZOFIA',
    value: 'rymanow-WILLA-ZOFIA-PDO',
    src: ''
  }, 
  {
    text: 'rzeszow-FORREST',
    value: 'rzeszow-FORREST-pobyt',
    src: ''
  },
  {
    text: 'rzeszow-FORREST',
    value: 'rzeszow-FORREST-wynajem',
    src: ''
  },
  {
    text: 'rzeszow-FORREST',
    value: 'rzeszow-FORREST-PDO',
    src: ''
  },
  {
    text: 'rzeszow-FORREST',
    value: 'rzeszow-FORREST-RSU',
    src: ''
  },  
  {
    text: 'rzeszow-HUBERTUS',
    value: 'rzeszow-HUBERTUS-pobyt',
    src: ''
  },
  {
    text: 'rzeszow-HUBERTUS',
    value: 'rzeszow-HUBERTUS-wynajem',
    src: ''
  },
  {
    text: 'rzeszow-HUBERTUS',
    value: 'rzeszow-HUBERTUS-PDO',
    src: ''
  },
  {
    text: 'rzeszow-HUBERTUS',
    value: 'rzeszow-HUBERTUS-RSU',
    src: ''
  }, 
  {
    text: 'rzeszow-MARAND-LOFT',
    value: 'rzeszow-MARAND-LOFT-pobyt',
    src: ''
  },
  {
    text: 'rzeszow-MARAND-LOFT',
    value: 'rzeszow-MARAND-LOFT-wynajem',
    src: ''
  },
  {
    text: 'rzeszow-MARAND-LOFT',
    value: 'rzeszow-MARAND-LOFT-PDO',
    src: ''
  },
  {
    text: 'rzeszow-MARAND-LOFT',
    value: 'rzeszow-MARAND-LOFT-RSU',
    src: ''
  },
  {
    text: 'Zielona-Góra-PCK',
    value: 'zielona-gora-PCK-pobyt',
    src: ''
  },
  {
    text: 'Zielona-Góra-PCK',
    value: 'zielona-gora-PCK-wynajem',
    src: ''
  },
  {
    text: 'Zielona-Góra-PCK',
    value: 'zielona-gora-PCK-PDO',
    src: ''
  },
]

//PM 2021-11-05
//text: 'Standard',
export const vscHotelBook: Aplikacja[] = [
  {
    text: 'polityka prywatności',
    value: 'Polityka',
    src: ''
  },
  {
    text: 'warunki korzystania z usługi',
    value: 'Warunki',
    src: ''
  },
]

class App extends React.Component<WithStyles<typeof styles>, AppState> {

  //PM 2021-10-11
  //obsluzenie sytuacji, kiedy nie wybrano zadnego regulaminu
  getRegulaminyValue = () => {
    switch (CONFIG.regulaminy) {
      case 'GooglePlay': return 0
      case 'AppGallery': return 1
      case 'CashBill': return 2
      case 'Przelewy24': return 3
      case 'TPay': return 4
      case 'PayU': return 5
      default: return -1
    }
  }

  //PM 2021-12-10
  //else if (CONFIG.regulaminy === 'Regulamin')
  getAplikacjaValue = () => {
    let returnAplikacja = new Aplikacja()

    if (CONFIG.regulaminy === 'GooglePlay' || CONFIG.regulaminy === 'AppGallery') {
      const aplikacja = aplikacje.find(a => a.value === CONFIG.aplikacja)

      if (aplikacja)
        returnAplikacja = aplikacja
    }
    else if (CONFIG.regulaminy === 'Przelewy24') {
      const aplikacja = platnosciPrzelewy24.find(a => a.value === CONFIG.aplikacja)

      if (aplikacja)
        returnAplikacja = aplikacja
      else
        returnAplikacja = platnosciPrzelewy24[0]
    }
    else if (CONFIG.regulaminy === 'TPay') {
      const aplikacja = platnosciTPay.find(a => a.value === CONFIG.aplikacja)

      if (aplikacja)
        returnAplikacja = aplikacja
      else
        returnAplikacja = platnosciTPay[0]
    }
    else if (CONFIG.regulaminy === 'Regulamin') {
      const aplikacja = Regulaminy.find(a => a.value === CONFIG.aplikacja)

      if (aplikacja)
        returnAplikacja = aplikacja
    }
    else if (CONFIG.regulaminy === 'vscHotelBook') {
      const aplikacja = vscHotelBook.find(a => a.value === CONFIG.aplikacja)

      if (aplikacja)
        returnAplikacja = aplikacja
    }

    return returnAplikacja
  }

  //PM 2021-11-17
  //window.addEventListener(...)
  constructor(props: WithStyles<typeof styles>) {
    super(props, {});
    window2config();

    this.state = {
      regulaminy: CONFIG.regulaminy,
      aplikacja: this.getAplikacjaValue(),
      value: this.getRegulaminyValue(),
      anchorEl: null,
      lang: "pl"
    }
  }

  openMenu = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  closeMenu = async () => {
    this.setState({ ...this.state, anchorEl: null });
  };

  selectMenu = async (aValue: number, aRegulaminy: string) => {
    this.setState({ ...this.state, value: aValue, regulaminy: aRegulaminy, aplikacja: new Aplikacja() });
  }

  setLang = (lang: string) => {
    this.setState({lang: lang})
  }

  //PM 2021-09-08
  //zmiana aplikacja na obiekt
  setAplikacja = (aAplikacja: Aplikacja) => {
    this.setState({ ...this.state, aplikacja: aAplikacja });
  }

  //PM 2021-10-11
  //obsluzenie sytuacji, kiedy nie wybrano zadnego regulaminu
  selectComponentTitle = () => {
    const { classes } = this.props;
    const regulaminy = menuItems[this.state.value]

    if (regulaminy)
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
          }}
          className={classes.justifyCenter}
        >
          <ImgIcon src={regulaminy.src} alt={regulaminy.alt} fontSize="large" />
          <Typography variant="h6" component="h2" color="primary">
            <b style={{ whiteSpace: window.innerWidth > 600 ? 'pre' : 'pre-line' }}>{(window.innerWidth > 600 ? '     ' : '') + regulaminy.text}</b>
          </Typography>
          <hr style={{ width: '100%' }} />
        </div>
      )
    else return null
  }

  //PM 2021-10-12
  //case 'TPay'
  getPlatnosci = () => {
    switch (this.state.regulaminy) {
      case 'Przelewy24': return platnosciPrzelewy24
      case 'TPay': return platnosciTPay
      default: return []
    }
  }

  //PM 2021-12-10
  //|| this.state.regulaminy === 'Regulamin'
  selectComponent = () => {
    if (this.state.regulaminy === 'GooglePlay'
      || this.state.regulaminy === 'AppGallery') {
      if (this.state.aplikacja.value !== '')
        return <CardPolityka aplikacja={this.state.aplikacja} />
      else return <LinksAplikacje setAplikacja={this.setAplikacja} />
    }
    else if (this.state.regulaminy === 'Przelewy24'
      || this.state.regulaminy === 'CashBill'
      || this.state.regulaminy === 'TPay'
      || this.state.regulaminy === 'PayU'
      || this.state.regulaminy === 'Regulamin') {
      if (this.state.aplikacja.value !== '')
        return <CardPlatnosc aplikacja={this.state.aplikacja} regulaminy={this.state.regulaminy} lang={this.state.lang}/>
      else return <LinksPlatnosci setAplikacja={this.setAplikacja} platnosci={this.getPlatnosci()} />
    }
    else if (this.state.regulaminy === 'Cookies')
      return <CardCookies />
    else if (this.state.regulaminy === 'vscHotelBook') {
      if (this.state.aplikacja.value !== '')
        return <CardWeb aplikacja={this.state.aplikacja} regulaminy={this.state.regulaminy} />
    }
    else if (this.state.regulaminy === 'Auth') {
      if (CONFIG.aplikacja === 'Google')
        return <Google />
      else if (CONFIG.aplikacja === 'Facebook')
        return <Facebook />
      else return <div></div>
    }
    else return <div></div>

  }

  //PM 2021-10-11
  //obsluzenie sytuacji, kiedy nie wybrano zadnego regulaminu
  opisRegulaminy = () => {
    const { classes } = this.props;

    return (
      <TableCell
        className={classes.headerCell}
        style={window.innerWidth > 600 ? {} : { margin: 'auto' }}
      >
        <Button
          variant="outlined" color="primary" size="small"
          className={`${classes.button}`} style={{ fontWeight: "bold", padding: "3px 15px", color: theme.palette.primary.main }}
        >
          {menuItems[this.state.value] ? menuItems[this.state.value].text : ''}
        </Button>
      </TableCell>
    )
  }

  //PM 2021-10-27
  //vscTest
  render() {
    //vscTest
    //console.log(CONFIG)
    const { classes } = this.props;
    const openMenu = Boolean(this.state.anchorEl);

    let showLang = CONFIG.aplikacja === "zary-HAYDUK-pobyt"

    return (
      <MuiThemeProvider theme={theme}>
        <Grid container spacing={8} justifyContent="center" style={{ width: '100%' }} className={classes.container}>
          <Grid item xl={8} lg={10} xs={12} className={classes.gridItem}>
            {CONFIG.regulaminy === 'GooglePlay' || CONFIG.regulaminy === 'AppGallery' ?
              (
                <Grid
                  item
                  xs={12}
                  md={8}
                  className={classes.gridItem2}
                >
                  <Paper className={classes.paper2} elevation={0}>
                    <Table className={classes.table} size="small">
                      <TableBody>
                        <TableRow style={{ display: "flex" }}>
                          <TableCell
                            className={classes.headerCell}
                            style={{ height: '46px' }}//, width: "0", padding: "5px 0px", margin: "0 -12px 0 12px"}}
                          >
                            <IconButton
                              aria-label="more"
                              aria-controls="long-menu"
                              aria-haspopup="true"
                              onClick={this.openMenu}
                            >
                              <MenuIcon />
                            </IconButton>
                            <Backdrop className={classes.backdrop} open={openMenu}>
                              <Menu
                                id="long-menu"
                                anchorEl={this.state.anchorEl}
                                keepMounted
                                elevation={15}
                                open={openMenu}
                                onClose={this.closeMenu}
                                PaperProps={{
                                  style: {
                                    //maxHeight: 10 * 4.5,
                                    left: "200px",
                                    top: "200px"
                                    //paddingTop: "0"
                                  },
                                }}

                                MenuListProps={{
                                  style: {
                                    //maxHeight: 10 * 4.5,
                                    //width: '30ch',
                                    color: "#555",
                                    //paddingTop: "0",
                                    //paddingBottom: "0"
                                  },
                                }}
                              >

                                {/*<hr/>*/}
                                {/* <Typography 
                                gutterBottom component="h6" style={{padding: "8px 16px"}}
                                color='textSecondary'
                              >
                                <b>{"Dane"}</b>
                              </Typography> */}
                                {menuItems.map((menuItem, index) => (
                                  <MenuItem
                                    key={menuItem.text}
                                    onClick={async () => {
                                      await this.selectMenu(index, menuItem.value)
                                      await this.closeMenu()
                                    }}
                                    className={menuItem.divider ? classes.divider : ''}
                                  >
                                    <ImgIcon src={menuItem.src} alt={menuItem.alt} />
                                    <Typography className={classes.menuText}
                                      color='textSecondary'
                                      variant='caption'
                                    >
                                      {menuItem.text}
                                    </Typography>
                                  </MenuItem>
                                ))}
                              </Menu>
                            </Backdrop>
                          </TableCell>
                          <TableCell className={classes.headerCell} style={{ margin: "auto" }}>
                            {menuItems.map((menuItem, index) => (
                              <IconButton
                                key={menuItem.text}
                                className={classes.padding0}
                                onClick={() => this.setState({ ...this.state, value: index, regulaminy: menuItem.value, aplikacja: new Aplikacja() })}
                              >
                                <ImgIcon src={menuItem.src} alt={menuItem.alt} />
                              </IconButton>
                            ))}
                            {/* <IconButton className={classes.padding0} style={{ color: "#3a87ad" }} onClick={this.toggleDialog}  >
                          <HistoryIcon className={classes.icon} titleAccess='historia wersji' />
                          <DialogWersja
                            open={this.state.openWersja}
                            toggleDialog={this.toggleDialog}
                            historiaWersji={historiaWersji} />
                        </IconButton> */}

                          </TableCell>
                          {window.innerWidth > 600 ? this.opisRegulaminy() : null}
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Paper>
                  {window.innerWidth > 600 ? null :
                    (
                      <Paper className={classes.paper2} elevation={0}>
                        <Table className={classes.table} size="small">
                          <TableBody>
                            <TableRow style={{ display: "flex" }}>
                              {this.opisRegulaminy()}
                            </TableRow>
                          </TableBody>
                        </Table>
                      </Paper>
                    )}
                  {this.state.aplikacja.value === '' ? this.selectComponentTitle() : null}
                </Grid>
              ) : null}
            {showLang ? <FlagIcons lang={this.state.lang} setLang={this.setLang} /> : null }
            {this.selectComponent()}
            <div id="footer">
              <div className={"copyrights"} style={{
                fontSize: "11px",
                fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
                lineHeight: "20px",
                fontWeight: 400, textAlign: "center"
              }}>
                <a style={{ color: "#458B00", textDecoration: "none" }}
                  href="http://www.virtualsc.com.pl">copyright © VIRTUAL sc, www.virtualsc.com.pl</a>{/*tel.(17) 85 070 85*/} <br />
              </div>
            </div>
          </Grid>
        </Grid>
      </MuiThemeProvider>
    );
  }
}

const styles = (theme: Theme) => ({
  container: {
    margin: 0
  },
  gridItem: {
    '&.MuiGrid-item': {
      paddingTop: 0,
    },
  },
  gridItem2: {
    margin: 'auto',
    paddingTop: theme.spacing(3)
  },
  paper2: {
    marginBottom: "1em",
    background: "linear-gradient(to bottom, #ffffff, #f7f7f7)",
    //padding: "16.9px 1px 11.9px ",
    width: "-webkit-fill-available"
  },
  table: {
    borderCollapse: "collapse" as "collapse"
  },
  headerCell: {
    borderBottom: "0",
    //color: "#555"
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  menuText: {
    fontSize: "0.85rem",
    whiteSpace: 'pre-wrap' as 'pre-wrap',
    marginLeft: '21.156px'
  },
  padding0: {
    padding: 0
  },
  icon: {
    padding: "4px 4px",
    cursor: "pointer"
  },
  button: {
    //color: "seagreen",
    //color: theme.palette.primary.main,
    minWidth: "0",
    fontSize: "11px",
    margin: "7.5px 3px",
    //width: "40px", 
    height: "31px",
    //padding: "3px 5px 0px",
    textTransform: "none" as "none",
    letterSpacing: "0px",
    borderRadius: "0px",
    // "&:hover":{
    //   borderRadius: "0px",
    // }
  },
  justifyCenter: {
    justifyContent: "center"
  },
  divider: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    backgroundClip: 'padding-box',
  },
});

export default withStyles(styles)(App);
